import { CellProps } from '../../../../components/reports/generic-table/cell-prod.component';
import {
  formatBigNumber,
  formatNumber,
  formatPercNumber,
} from '../../../../utils/formatting/number-formatter.helper';
import { ScenarioPlannerNumberCellTooltipComponent } from './scenario-planner-number-cell-tooltip.component';

export const ScenarioPlannerNumberCellComponent = ({
  data,
  col,
}: CellProps) => {
  const value = data && col ? data[col.id] : 0;
  // In case we have the flag in the data we have to assign a different className to highlight the value.
  const isModified = data && col ? data[`${col.id}IsModified`] === true : false;
  const isApupCurrent = col?.id === 'apup_CURRENT';
  const showTooltip = isApupCurrent;
  let formattedValue = value;
  if (col?.format === 'percentage') {
    formattedValue = `${formatPercNumber(formattedValue * 100)}%`;
  } else {
    if (col?.format?.type === 'bigNumber') {
      formattedValue = formatBigNumber(
        formattedValue,
        col.format?.currencyCode,
        col.format,
      );
    } else {
      formattedValue = formatNumber(
        formattedValue,
        col?.format,
        col?.format?.currencyCode,
      );
    }
  }
  const className = value > 0 ? 'positive' : value < 0 ? 'negative' : '';
  const isModifiedClassName = isModified ? 'is-modified' : '';
  if (showTooltip) {
    return (
      <ScenarioPlannerNumberCellTooltipComponent
        data={data}
        formattedValue={formattedValue}
        className={`scenario-table-cell ${className} ${isModifiedClassName}`}
      />
    );
  } else {
    return (
      <div
        className={`scenario-table-cell ${className} ${isModifiedClassName}`}
      >
        <span>{formattedValue}</span>
      </div>
    );
  }
};
